import { Directive, Host, OnDestroy, Component, Output, EventEmitter, OnInit, Input, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EditorResizableOptions } from "@progress/kendo-angular-editor";

import { ToolBarButtonComponent, DisplayMode } from '@progress/kendo-angular-toolbar';
import { EditorComponent } from '@progress/kendo-angular-editor';
//import { radiobuttonCheckedIcon, radiobuttonIcon, SVGIcon } from '@progress/kendo-svg-icons';
import { Subscription } from 'rxjs';

@Component({
    selector: 'wachter-note-editor',
    templateUrl: './wachter-note-editor.component.html',
    styleUrls: ['./wachter-note-editor.component.scss']
})
export class WachterNoteEditorComponent implements OnInit {
    @Input() note: string = '';

    public expanded: boolean = false;
    public resizable: boolean | EditorResizableOptions = {
        minWidth: 300,
        minHeight: 220,
        // maxWidth: 600,
        maxHeight: 450,
    };

    @Output() noteChange = new EventEmitter<any>();

    ngOnInit(): void {
        //this.resizable = false;
    }
    onPaste(e){
        /* Ported from Trust */
        e.cleanedHtml= e.originalHtml;
    }
    onValueChange(e){
        this.noteChange.emit(e); 
    }
}

@Pipe({ name: 'renderHtml', pure: true })
export class SanitizeHtmlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }
    /* May not be needed after all */
    transform(content) { 
        const html = this.sanitizer.bypassSecurityTrustHtml(content); 
        //const html = this.sanitizer.bypassSecurityTrustResourceUrl(content);
        return html;
    }
}

@Directive({
    selector: 'kendo-toolbar-button[toggleToolbar]'
})
export class ToggleToolbar implements OnInit, OnDestroy {

    private subs: Subscription[] = [];
    constructor(
        private button: ToolBarButtonComponent,
        @Host() private editor: WachterNoteEditorComponent
    ) {}

    public ngOnInit(): void {
        this.subs.push(
            this.button.click.subscribe(() => { this.editor.expanded = !this.editor.expanded; })
        );
    }
  
    public ngOnDestroy(): void {
        this.subs.forEach((sub) => sub.unsubscribe());
    }
}